import axios from 'axios';
import * as httpClient from './http-client';
import store from '../../storeClient';

function search(nameKey, myArray) {
  for (let i = 0; i < myArray.length; i++) {
    if (myArray[i].code === nameKey) {
      return myArray[i];
    }
  }
  return null;
}

function checkCache(code) {
  if (
    sessionStorage.getItem('cacheCities') !== null &&
    sessionStorage.getItem('cacheCities') !== '' &&
    sessionStorage.getItem('cacheCities') !== undefined
  ) {
    const lista = JSON.parse(sessionStorage.getItem('cacheCities'));
    const resultObject = search(code, lista);
    if (resultObject !== undefined) {
      return resultObject;
    }
  }
  return undefined;
}

export default {
  getDestinations(words) {
    const { token } = store.getState().applicationState;
    return axios
      .get(`${process.env.RAZZLE_API_GEO}/ciudad?search=${words}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => res.data);
  },

  async getProvincias() {
    const { token } = store.getState().applicationState;
    return axios
      .get(`${process.env.RAZZLE_API_GEO}/provincia`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => res.data);
  },
  async getLocalidades() {
    const { token } = store.getState().applicationState;
    return axios
      .get(`${process.env.RAZZLE_API_GEO}/localidad`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => res.data);
  },
  async getCityByCode(code) {
    // comprobar si existe en session storege
    const fromCache = await checkCache(code);
    if (fromCache) {
      return Promise.resolve(fromCache);
    }
    const { token } = store.getState().applicationState;
    return axios
      .get(`${process.env.RAZZLE_API_GEO}/ciudad?codigo=${code}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        let list;
        const cache = sessionStorage.getItem('cacheCities');
        if (cache !== null && cache !== '' && cache !== undefined) {
          list = JSON.parse(cache);
        } else {
          list = [];
        }

        list.push(res.data);
        sessionStorage.setItem('cacheCities', JSON.stringify(list));
        return res.data;
      });
  },
  async standAloneGetCityByCode(code) {
    return axios
      .get(`${process.env.RAZZLE_API_GEO}/ciudad?codigo=${code}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        return res.data;
      });
  },
  async getOriginByApi(token) {
    return httpClient
      .getWithToken(`${process.env.RAZZLE_API_PAQUETES}/OrigenDestino/obtener-origen`, token)
      .then((res) => {
        return res.data;
      });
  },
  async getDestinyByApi(code, token) {
    const origin = {
      codigo_origen: code,
    };
    return httpClient
      .postWithToken(
        `${process.env.RAZZLE_API_PAQUETES}/OrigenDestino/obtener-destino/`,
        origin,
        token
      )
      .then((res) => {
        return res.data;
      });
  },
  async getMonthByApi(ori, des, token) {
    const fecha = {
      codigo_origen: ori,
      codigo_destino: des,
    };
    return httpClient
      .postWithToken(
        `${process.env.RAZZLE_API_PAQUETES}/OrigenDestino/obtener-periodo`,
        fecha,
        token
      )
      .then((res) => {
        return res.data;
      });
  },
};
